module.exports = __webpack_public_path__ + "static/media/Hover3_LA.76155eec.png";